<template>
  <div>
    <b-overlay :show="showOverlay" rounded="sm" spinner-variant="primary">
      <ValidationObserver ref="searchForm" slim>
        <b-form @submit.prevent="submit" class="filters-form">
          <b-col md="12">
            <h5 class="search-title">Excursii</h5>
            <b-form-row>
              <b-col md="2">
                <b-form-group
                  label="Moneda"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="currency"
                >
                <b-form-select
                  class="mv-form-control form-control"
                  id="currency"
                  size="sm"
                  v-model="selectedParams.currency"
                  @change="onCurrencyChange"
                  :options="[ { value: 'EUR', text: 'EUR' }, { value: 'RON', text: 'RON' } ]"
                ></b-form-select>
              </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="Plecare din"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="car_type"
                >
                  <b-form-select
                    class="mv-form-control form-control"
                    id="car_type"
                    size="sm"
                    v-model="selectedParams.product_tag"
                    @change="onProductChange"
                    :options="productOptions"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="null">-- selecteaza --</b-form-select-option>
                  </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="Destinatie"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="transfer_from"
                  >
                  <b-form-select
                    class="mv-form-control form-control"
                    id="transfer_from"
                    size="sm"
                    v-model="selectedParams.place"
                    @change="onPlaceChange"
                    :options="areasOptions"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="null">-- selecteaza --</b-form-select-option>
                  </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <ValidationProvider
                  name="Date"
                  :rules="{ required: true }"
                  vid="checkIn"
                  v-slot="vContext"
                  >
                  <b-form-group
                    label="Data"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="checkIn">
                    <b-form-select
                      class="mv-form-control form-control"
                      id="transfer_from"
                      size="sm"
                      v-model="selectedParams.date"
                      :options="dateOptions"
                      :state="getValidationState(vContext)"
                    >
                     <b-form-select-option :value="null">-- selecteaza --</b-form-select-option>
                    </b-form-select>
                    <b-form-invalid-feedback id="checkin-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="Flexibilitate"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="flexibility"
                  >
                  <b-form-select
                    class="mv-form-control form-control"
                    id="flexibility"
                    size="sm"
                    v-model="selectedParams.date_flexibility"
                    :options="dateFlexibilityOptions"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="3">
                <b-form-group
                  label="Cuvant cheie"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="keyword"
                  >
                  <b-form-input id="keyword" name="keyword" v-model="selectedParams.keyword" size="sm"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="Pasageri"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="passengers">
                  <room
                    v-model="room"
                    :id="room"
                    :showDelete="false"
                    :showAdd = "false"
                  />
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col sm="12" class="d-flex align-items-center justify-content-end">
                <b-button variant="outline-primary"  size="sm" type="submit"><b-icon icon="search" /><span class="ml-2">Cauta</span></b-button>
              </b-col>
            </b-form-row>
          </b-col>
        </b-form>
      </ValidationObserver>
    </b-overlay>
  </div>
</template>

<script>
import moment from 'moment'

import formMixin from '@/app/private/shared/mixins/search_forms'
import validation from 'b2b-common/mixins/validation'
import toast from 'b2b-common/mixins/toast'

import Room from '@/app/private/shared/components/search_form_room.vue'

import {
  getDestinationPoints,
  getProductTags,
  getAllocDates
} from 'b2b-common/services/api/other'

export default {
  name: 'searchForm',
  components: { Room },
  mixins: [formMixin, validation, toast],
  props: ['params'],
  data () {
    return {
      selectedParams: {
        adults: 2,
        child_ages: [],
        contracts: [],
        done: false,
        date: null,
        date_flexibility: 0,
        return_date: null,
        place: null,
        keyword: ''
      },
      defaultNights: 7,
      areasList: [],
      productTagsList: [],
      datesList: [],
      room: {
        adults: 1,
        ages: []
      }
    }
  },
  methods: {
    async getDestinationPointsList () {
      this.resetList('areas')
      this.addRequest('areas')
      try {
        const res = await getDestinationPoints({
          currency: this.selectedParams.currency,
          product_tag: this.selectedParams.product_tag
        })
        this.areasList = res
      } finally { this.removeRequest('areas') }
      return this.areasList
    },
    async getProductTagsList () {
      this.resetList('products')
      this.addRequest('products')
      try {
        const res = await getProductTags({
          currency: this.selectedParams.currency
        })
        this.productTagsList = res
      } finally { this.removeRequest('products') }
      return this.areasList
    },
    async getDatesList () {
      this.resetList('dates')
      this.addRequest('dates')
      try {
        const res = await getAllocDates({
          currency: this.selectedParams.currency,
          product_tag: this.selectedParams.product_tag,
          destination: this.selectedParams.place
        })
        this.datesList = res.map(el => el.date)
      } finally { this.removeRequest('dates') }
      return this.datesList
    },
    async onCurrencyChange (val) {
      await this.getProductTagsList()
      await this.getDestinationPointsList()
      await this.getDatesList()
    },
    async onProductChange (val) {
      await this.getDestinationPointsList()
      await this.getDatesList()
    },
    async onPlaceChange (val) {
      await this.getDatesList()
    },
    submit () {
      this.$refs.searchForm.validate().then(success => {
        if (!success) {
          this.addToast({
            title: 'Formular invalid',
            message: 'Va rugam sa completati toate campurile!',
            variant: 'danger'
          })
        } else {
          this.selectedParams.adults = this.room.adults
          this.selectedParams.child_ages = this.room.ages
          this.selectedParams.return_date = this.selectedParams.date
          this.onSubmit()
        }
      })
    }
  },
  computed: {
    dateFlexibilityOptions () {
      return [
        { value: 0, text: 'Data exacta' },
        { value: 3, text: '+/- 3 zile' },
        { value: 5, text: '+/- 5 zile' },
        { value: 10, text: '+/- 10 zile' },
        { value: 15, text: '+/- 15 zile' },
        { value: 20, text: '+/- 20 zile' },
        { value: 30, text: '+/- 30 zile' }
      ]
    },
    selectedCheckIn: {
      get () {
        const mVal = moment(this.selectedParams.date, 'DD-MM-YYYY')
        if (mVal.isValid()) return mVal.toDate()
        return null
      },
      set (val) {
        this.selectedParams.date = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    selectedCheckOut: {
      get () {
        const mVal = moment(this.selectedParams.return_date, 'DD-MM-YYYY')
        if (mVal.isValid()) return mVal.toDate()
        return null
      },
      set (val) {
        this.selectedParams.return_date = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    nights: {
      get () {
        if (this.selectedParams.checkIn && this.selectedParams.checkOut) {
          return moment(this.selectedCheckOut).startOf('day').diff(moment(this.selectedCheckIn).startOf('day'), 'days')
        }
        return this.defaultNights
      },
      set (val) {
        if (val === null || val === undefined || val === '' || val < 0) return
        this.defaultNights = val
        if (this.selectedCheckIn) {
          const start = moment(this.selectedCheckIn)
          const end = (this.selectedCheckOut) ? moment(this.selectedCheckOut) : moment(start).set('hour', 11).set('minute', 0)
          const eodStart = moment(start).startOf('day')
          const eodEnd = moment(end).startOf('day')
          const currentNights = eodEnd.diff(eodStart, 'days')
          this.selectedCheckOut = end.add(val - currentNights, 'days').toDate()
        }
      }
    },
    areasOptions () {
      return this.areasList.map(el => ({ value: el.id, text: el.name }))
    },
    productOptions () {
      return this.productTagsList.map(el => ({ value: el.id, text: el.label }))
    },
    dateOptions () {
      return this.datesList.map(el => {
        const text = moment(el, 'YYYY-MM-DD').format('DD-MM-YYYY')
        return { value: text, text }
      })
    },
    showOverlay () { return this.activeRequests.length > 0 }
  },
  async created () {
    this.selectedParams = { ...this.params }
    this.getDestinationPointsList()
    this.getProductTagsList()
    await this.getDatesList()
    if (this.selectedParams.date) {
      const mom = moment(this.selectedParams.date, 'DD-MM-YYYY').format('YYYY-MM-DD')
      if (!this.datesList.find(el => el === mom)) this.selectedParams.date = null
    }
    this.room.adults = this.selectedParams.adults
    this.room.ages = this.selectedParams.child_ages
  }
}
</script>

<style lang="scss" scoped></style>
